var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.collapseId),expression:"collapseId"}],staticClass:"rounded-0",attrs:{"variant":"link"}},[_c('i',{staticClass:"when-opened fas fa-caret-down fa-2x"}),_c('i',{staticClass:"when-closed fas fa-caret-right fa-2x"})])
}
var staticRenderFns = []

export { render, staticRenderFns }